export default "__VITE_ASSET__BxiiWO1O__"